module.exports = __webpack_public_path__ + "img/green-arrow-down.abaa38a5.svg";